export const GET_WALLET_DATA = 'GET_WALLET_DATA';
export const SET_WALLET_DATA = 'SET_WALLET_DATA';
export const SET_GPMS_LOCALE = 'SET_GPMS_LOCALE';
export const SET_WALLET_DATA_ERROR = 'SET_WALLET_DATA_ERROR';
export const WALLET_LOAD_ERROR = 'WALLET_LOAD_ERROR';